<template>
  <div>
    <div>
      <ul class="mt-3" @change="$emit('input', selectedMethod)">
        <li
          class="py-2 flex"
          v-for="paymentMethod in paymentMethods"
          :key="paymentMethod.code"
        >
          <input type="radio" :value="paymentMethod.code" v-model="selectedMethod"
          :id="paymentMethod.code" role="checkbox">
          <label :for="paymentMethod.code" class="pl-1 text-xs w-full">
            {{ $t(paymentMethod.name) }}
          </label>
          <div class="flex justify-end items-center h-4"
          v-if="paymentMethod.code === 'card'">
            <mastercard-logo aria-label="Mastercard" class="bg-background-academy
            rounded-lg h-10 mr-2" />
            <amex-logo aria-label="American Express"/>
            <visa-logo aria-label="Visa" class="pl-2"/>
          </div>
          <div class="flex justify-end items-center w-48 h-5"
          v-if="paymentMethod.code === 'paypal'">
            <paypal-logo-black aria-label="Paypal"/>
          </div>
          <div class="flex justify-end items-center h-5"
          v-if="paymentMethod.code === 'sepa'">
            <img src="/sepa.png" alt="Sepa Direct Debit" class="w-12">
          </div>
        </li>
      </ul>
    </div>
    <!-- <keep-alive v-if="selectedMethod!=='paypal' && !hasDefault">
      <component class="mt-10" :is="selectedMethod" @updated-payment-method="updatedDefault" />
    </keep-alive> -->
    <cards-list v-if="selectedMethod === 'card'"
      :radioButtons="true" class="mt-10"
      v-model="selectedStripeMethodId" />
    <iban-list v-if="selectedMethod === 'sepa'"
      :radioButtons="true" class="mt-10"
      v-model="selectedStripeMethodId" />
    <default-payment-method v-if="hasDefault" class="my-10" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MastercardLogo from '../logos/MastercardLogo.vue';
import AmexLogo from '../logos/AmexLogo.vue';
import VisaLogo from '../logos/VisaLogo.vue';
import PaypalLogoBlack from '../logos/PaypalLogoBlack.vue';
// import Stripe from './Stripe.vue';
// import Sepa from './Sepa.vue';
import DefaultPaymentMethod from './DefaultPaymentMethod.vue';
import CardsList from './CardsList.vue';
import IbanList from './IbanList.vue';

export default {
  components: {
    AmexLogo,
    VisaLogo,
    PaypalLogoBlack,
    MastercardLogo,
    DefaultPaymentMethod,
    CardsList,
    IbanList,
  },

  props: ['value'],

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),
  },

  data() {
    return {
      paymentMethods: [
        {
          code: 'card',
          name: 'payments.stripe',
        },
        {
          code: 'paypal',
          name: 'payments.paypal',
        },
      ],
      selectedMethod: this.value,
      selectedStripeMethodId: null,
      hasDefault: false,
    };
  },

  watch: {
    selectedStripeMethodId() {
      this.$emit('stripe-changed', this.selectedStripeMethodId);
    },
  },

  methods: {
    updatedDefault() {
      this.$store.dispatch('auth/auth').then(() => {
        this.hasDefault = true;
        this.createNotification('success', this.$t('payments.success'));
      });
    },
  },

};
</script>
